(function(){
  if(window.__zanorCartLookInitialized)return;
  window.__zanorCartLookInitialized=true;
  document.addEventListener('change',function(event){
    const select=event.target.closest?.('[data-zcl-size]');
    if(!select)return;
    const price=select.closest('[data-zanor-cart-look]')?.querySelector('[data-zcl-price]');
    if(price&&select.selectedOptions[0])price.textContent=select.selectedOptions[0].dataset.price||price.textContent;
  });
  document.addEventListener('click',async function(event){
    const button=event.target.closest?.('[data-zcl-add]');
    if(!button||button.disabled)return;
    const box=button.closest('[data-zanor-cart-look]');
    const variant=box?.querySelector('[data-zcl-size]')?.selectedOptions?.[0];
    if(!variant||variant.disabled)return;
    const error=box.querySelector('[data-zcl-error]');
    error.hidden=true;
    button.disabled=true;
    button.textContent='ADDING…';
    try{
      if(!window.ZanorCartUI)throw new Error('Cart is loading. Please try again.');
      await window.ZanorCartUI.addItems([{id:Number(variant.value),quantity:1}]);
    }catch(e){
      if(error.isConnected){error.textContent=e.message||'Unable to add matching piece.';error.hidden=false;}
    }finally{
      if(button.isConnected){button.disabled=false;button.textContent='ADD';}
    }
  });
})();